module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-12.2463024f.png";